<template>
    <div>
        <app-table
            id="documents-table"
            :options="options"
            @action="triggerActions"
        />

        <app-document-create-edit-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            :user-id="props.id"
        />

        <app-document-image-editor-modal
            v-if="isImageEditorActive"
            v-model="isImageEditorActive"
            :files="imageEditorFiles"
            :row-data="imageEditorRow"
            :selected-path="imageEditorSelectedPath"
            :saving="imageEditorSaving"
            @save="saveEditedImage"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('documents-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import DeleteMixin from "../../../../../../common/Mixin/Global/DeleteMixin";
import HelperMixin from "../../../../../../common/Mixin/Global/HelperMixin";
import DocumentMixins from "../../../../Mixins/DocumentMixins";
import TriggerActionMixin from "../../../../../../common/Mixin/Global/TriggerActionMixin";
import {axiosPost} from "../../../../../../common/Helper/AxiosHelper";
import {DOCUMENTS} from "../../../../../Config/ApiUrl";

export default {
    name  : "Document",
    mixins: [HelperMixin, DocumentMixins, TriggerActionMixin, DeleteMixin],
    props : {
        props: {
            default: ''
        },
        id   : {
            type: String
        }
    },
    data() {
        return {
            selectedUrl            : '',
            isModalActive          : false,
            isImageEditorActive    : false,
            imageEditorFiles       : [],
            imageEditorRow         : {},
            imageEditorSelectedPath: '',
            imageEditorSaving      : false,
            confirmationModalActive: false
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.name === 'edit') {
                this.selectedUrl   = `${this.apiUrl.DOCUMENTS}/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openImageEditor({rowData, files, selectedPath}) {
            this.imageEditorRow = rowData;
            this.imageEditorFiles = files;
            this.imageEditorSelectedPath = selectedPath;
            this.isImageEditorActive = true;
        },
        saveEditedImage({file, rowData}) {
            const formData = new FormData();

            formData.append('_method', 'PATCH');
            formData.append('name', rowData.name);
            formData.append('verified', Number(rowData.verified) === 1 ? 'true' : 'false');
            formData.append('files[]', file);

            if (rowData.expired) {
                formData.append('expired', rowData.expired);
            }

            this.imageEditorSaving = true;

            axiosPost(`${DOCUMENTS}/${rowData.id}`, formData).then(({data}) => {
                this.$toastr.s('', data.message);
                $('#document-image-editor-modal').modal('hide');
                this.$hub.$emit('reload-documents-table');
            }).catch(error => {
                this.$toastr.e('', error.response?.data?.message || 'Could not save image.');
            }).finally(() => {
                this.imageEditorSaving = false;
            });
        },
    },
    mounted() {
        this.$hub.$on('headerButtonClicked-' + this.id, (component) => {
            this.isModalActive = true;
            this.selectedUrl   = '';
        })
        this.$hub.$on('open-document-image-editor', this.openImageEditor)
    },
    beforeDestroy() {
        this.$hub.$off('open-document-image-editor', this.openImageEditor)
    },
}
</script>
